<script>
    import { getName, LogOut, checkCookie, setCookie, getCookie } from '../utils/utils.js';
    var name = "";
    name = getName() || "Test";
    var user_id = undefined
    if( checkCookie('access.6bgdz9n7') ) {
        const accessToken = getCookie('access.6bgdz9n7')
        const payload = accessToken.split('.')[1]
        const jstring = atob(payload)//.toString('base64') //TODO: change deprecated  function
        const obj = JSON.parse(jstring)
        user_id = obj.userId
        console.log("User id is "+user_id)
        
    }
    $: console.log('User id is ' + user_id);
    let balance = 0
    $: console.log('The balance is ' + balance);

    async function checkBalance(user_id) {
		  let res = await fetch(
          "/api/user/balance/"+user_id, 
          {
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'same-origin', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Authorization': `Bearer ${getCookie("access.6bgdz9n7")}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
               // no body in GET
          }
        );
        let retrieved_data = await res.json()
        console.log(retrieved_data)
        balance = retrieved_data.balance;
        return balance
	  }


    if( user_id != undefined) {
        checkBalance(user_id)
    }

</script>

<li><a href="https://www.radeger.com/user" id="name">User: {name || "Test"}</a></li>
<!--<li><a href="#tenant" id="tenant">Tenant: "Rolce Gears ltd"</a></li>-->
<li><a href="#balance">Balance: {balance}€</a></li>


<style>

  
  li {
    float: left;
    border-left: none;
    border-right:1px solid #bbb;
  }
  
 
  
  
  li a {
    display: block;
    color: white;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
  }
  
  li a:hover:not(.active) {
    background-color: #111;
  }
  
</style>